import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const FeedbackLanding = React.lazy(() => import('./FeedbackLanding'));
const DriverFeedBackTable = React.lazy(() =>
  import('../Master/DriverFeedBack/Table'),
);
const OverallFeedBackTable = React.lazy(() =>
  import('../Master/OverallFeedBack/Table'),
);
const RouteFeedBackTable = React.lazy(() =>
  import('../Master/RouteFeedBack/Table'),
);
const CabFeedBackTable = React.lazy(() =>
  import('../Master/CabFeedBack/Table'),
);
const SafetyFeedBackTable = React.lazy(() =>
  import('../Master/SafetyFeedBack/Table'),
);
const EscortFeedBackTable = React.lazy(() =>
  import('../Master/EscortFeedBack/Table'),
);

export const FeedbacksConfigs = [
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/feedbacks',
    element: <FeedbackLanding />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/feedbacks/drivers',
    element: <DriverFeedBackTable />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/feedbacks/overall',
    element: <OverallFeedBackTable />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/feedbacks/route',
    element: <RouteFeedBackTable />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/feedbacks/cab',
    element: <CabFeedBackTable />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/feedbacks/safety',
    element: <SafetyFeedBackTable />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/feedbacks/escort',
    element: <EscortFeedBackTable />,
  },
];
